module.exports = __webpack_public_path__ + "images/e4c1f73f9de13fc29116919f1e9bc561.jpg";